var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.blobUrl)?_c('div',{staticClass:"image-blob"},[_c('img',{ref:"image",attrs:{"src":_vm.blobUrl}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }